document.addEventListener('DOMContentLoaded', () => {
  const mainImage = document.querySelector('.product-image');
  const thumbnails = document.querySelectorAll('.thumbnail');
  const lightbox = document.createElement('div');
  lightbox.classList.add('fixed', 'inset-0', 'bg-black', 'bg-opacity-75', 'hidden', 'z-50', 'flex', 'items-center', 'justify-center');
  lightbox.innerHTML = `
    <div class="relative max-w-3xl mx-auto">
      <img id="lightbox-image" class="w-full rounded-lg" src="" alt="" data-index="0">
      <button class="absolute top-2 right-2 text-white" onclick="closeLightbox()" aria-label="Cerrar galería">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
      </button>
      <button class="absolute left-2 top-1/2 transform -translate-y-1/2 text-white" onclick="prevImage()" aria-label="Imagen anterior">
        <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/></svg>
      </button>
      <button class="absolute right-2 top-1/2 transform -translate-y-1/2 text-white" onclick="nextImage()" aria-label="Imagen siguiente">
        <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/></svg>
      </button>
    </div>
  `;
  document.body.appendChild(lightbox);

  function closeLightbox() {
    document.querySelector('.fixed.inset-0').classList.add('hidden');
  }

  function nextImage() {
    const thumbnails = document.querySelectorAll('.thumbnail');
    let currentIndex = parseInt(document.getElementById('lightbox-image').dataset.index || 0);
    currentIndex = (currentIndex + 1) % thumbnails.length;
    const lightboxImage = document.getElementById('lightbox-image');
    if (lightboxImage && thumbnails[currentIndex]) {
      lightboxImage.src = thumbnails[currentIndex].dataset.src || thumbnails[currentIndex].src || '/files/placeholder.jpg';
      lightboxImage.dataset.index = currentIndex;
    }
  }

  function prevImage() {
    const thumbnails = document.querySelectorAll('.thumbnail');
    let currentIndex = parseInt(document.getElementById('lightbox-image').dataset.index || 0);
    currentIndex = (currentIndex - 1 + thumbnails.length) % thumbnails.length;
    const lightboxImage = document.getElementById('lightbox-image');
    if (lightboxImage && thumbnails[currentIndex]) {
      lightboxImage.src = thumbnails[currentIndex].dataset.src || thumbnails[currentIndex].src || '/files/placeholder.jpg';
      lightboxImage.dataset.index = currentIndex;
    }
  }

  function openLightbox(src, index) {
    const lightboxImage = document.getElementById('lightbox-image');
    if (lightboxImage) {
      lightboxImage.src = src || '/files/placeholder.jpg';
      lightboxImage.dataset.index = index;
      lightbox.classList.remove('hidden');
    } else {
      console.warn('Elemento #lightbox-image no encontrado');
    }
  }

  if (mainImage) {
    mainImage.addEventListener('click', () => openLightbox(mainImage.dataset.src || mainImage.src, 0));
    mainImage.addEventListener('mousemove', (e) => {
      const rect = mainImage.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width * 100;
      const y = (e.clientY - rect.top) / rect.height * 100;
      mainImage.style.transformOrigin = `${x}% ${y}%`;
      mainImage.style.transform = 'scale(2)';
    });
    mainImage.addEventListener('mouseleave', () => {
      mainImage.style.transform = 'scale(1)';
    });
  } else {
    console.warn('Elemento .product-image no encontrado');
  }

  thumbnails.forEach((thumb, index) => {
    thumb.addEventListener('click', () => {
      if (mainImage) {
        mainImage.src = thumb.dataset.src || thumb.src;
        mainImage.dataset.src = thumb.dataset.src || thumb.src;
      }
      openLightbox(thumb.dataset.src || thumb.src, index);
    });
  });
});